import { render, staticRenderFns } from "./button-blue.pug?vue&type=template&id=a0820f10&lang=pug&external"
import script from "./button-blue.js?vue&type=script&lang=js&external"
export * from "./button-blue.js?vue&type=script&lang=js&external"
import style0 from "./button-blue.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0820f10')) {
      api.createRecord('a0820f10', component.options)
    } else {
      api.reload('a0820f10', component.options)
    }
    module.hot.accept("./button-blue.pug?vue&type=template&id=a0820f10&lang=pug&external", function () {
      api.rerender('a0820f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/button-blue/index.vue"
export default component.exports